import React from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { ReactComponent as ArrowLeft } from '../../img/left-arrow.svg';
import { ReactComponent as ArrowRight } from '../../img/right-arrow.svg';
import { useStyles } from './helpers';
import { useRouter } from '../../useRouter';

const TableCasino = ({ allPage, perPage, columns, rows, changePage, changeRowsPerPage, width, pagination, route, order, changeStatus, height, updateStatus, orderByDefault, handleClick }) => {
    const classes = useStyles();
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(perPage);
    const [orderBy, setOrderBy] = React.useState(orderByDefault);
    const router = useRouter();

    return (
        <div style={{ maxWidth: width }} className={classes.w100}>
            <TableContainer className={classes.container} >
                <Table stickyHeader aria-label="sticky table" >
                    <TableHead >
                        <TableRow className={classes.h25}>
                            {columns.map((column, key) => (
                                <TableCell
                                    key={column.id}
                                    align={column.align}
                                    onClick={() => {
                                        if (order && column?.sort) {
                                            const temp_sort = orderBy.split(',');
                                            if (temp_sort?.[0] === column.id) {
                                                order({...column, sort: temp_sort?.[1] === 'desc' ? 'asc' : 'desc', rowsPerPage});
                                                setOrderBy(`${column.id},${temp_sort?.[1] === 'desc' ? 'asc' : 'desc'}`)
                                            } else {
                                                order({...column, sort: 'desc', rowsPerPage});
                                                setOrderBy(`${column.id},desc`)
                                            }
                                        }
                                    }}
                                    style={{ minWidth: column.minWidth, paddingLeft: key === 0 ? 10 : 0, cursor: order && column?.sort ? 'pointer' : 'default' }}
                                    className={classes.cell}
                                >
                                    {column.label}
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody className={classes.w100}>
                        {rows.map((row, key) => {
                            return (
                                <TableRow hover role="checkbox" tabIndex={-1} key={row.code} style={{ background: key % 2 === 0 ? '#141b33' : '#1b2039', cursor: route || changeStatus ? 'pointer' : 'default', height: height ? height : 50 }}
                                    onDoubleClick={() => {
                                        if (route) {
                                            router.history.push(route + row.id);
                                        }
                                        if (changeStatus) {
                                            changeStatus(row.id);
                                        }

                                        if (handleClick) {
                                            handleClick(row)
                                        }
                                    }}
                                >
                                    {columns.map((column, key) => {
                                        const value = row[column.id];

                                        return (
                                            <TableCell key={column.id} align={column.align} style={{ paddingLeft: key === 0 ? 10 : 0 }} className={classes.cellBody}>
                                                {column.format && typeof value === 'number' ? column.format(value) : value}
                                                {
                                                    column.id === 'status' && !!value && updateStatus &&
                                                    <span
                                                        onClick={() => {
                                                            updateStatus({
                                                                status: false,
                                                                uuid: row['uuid']
                                                            })
                                                        }}
                                                        style={{
                                                            color: '#141b33',
                                                            cursor: 'pointer',
                                                            padding: '10px',
                                                            background: '#ffc324',
                                                            borderRadius: '4px',
                                                        }}>
                                                        Выключить
                                                    </span>
                                                }
                                                {
                                                    column.id === 'status' && !!!value && updateStatus &&
                                                    <span
                                                        onClick={() => {
                                                            updateStatus({
                                                                status: true,
                                                                uuid: row['uuid']
                                                            })
                                                        }}
                                                        style={{
                                                            color: '#141b33',
                                                            cursor: 'pointer',
                                                            padding: '10px',
                                                            background: '#ffc324',
                                                            borderRadius: '4px',
                                                        }}>
                                                        Включить
                                                    </span>
                                                }
                                            </TableCell>
                                        );
                                    })}
                                </TableRow>
                            );
                        })}
                    </TableBody>


                </Table>
                {
                    rows.length === 0 &&

                    <div className={classes.wrapnodata}>
                        <span className={classes.nodata}>Данных нет</span>
                    </div>

                }
            </TableContainer>
            {
                pagination &&
                <div className={classes.wrapPagination}>
                    <select
                        className={classes.select}
                        value={rowsPerPage}
                        onChange={(v) => {
                            setRowsPerPage(v.target.value);
                            changeRowsPerPage({
                                page: page,
                                rowsPerPage: v.target.value
                            });
                        }}
                    >
                        <option value={10}>10</option>
                        <option value={25}>25</option>
                        <option value={50}>50</option>
                        <option value={500}>500</option>
                    </select>
                    <input type="number" onChange={(v) => setPage(v.target.value)} value={page + 1} className={classes.inputnumber} />
                    <span className={classes.countPage}>/ {allPage}</span>
                    <div className={classes.ml12}>
                        <span className={classes.arrowleft} onClick={() => {
                            if (page !== 0) {
                                changePage({ page: page - 1, rowsPerPage: +rowsPerPage })
                                setPage(page - 1)
                            }

                        }}>
                            <ArrowLeft className={classes.arrowRight} />
                        </span>
                        <span className={classes.arrowright} onClick={() => {
                            if (page !== +allPage - 1) {
                                changePage({ page: page + 1, rowsPerPage: +rowsPerPage })
                                setPage(page + 1)
                            }
                        }}>
                            <ArrowRight className={classes.arrowRight} />
                        </span>
                    </div>
                </div>
            }
        </div>
    )
}

export default TableCasino;